import React from "react";
import { FiHeart } from "react-icons/fi";
export default function ProductCard({ name, price, mrp, image }) {
    return (
        <div className="product-card">
            <div className="discount-badge">50% OFF</div>
            <div className="wishlist-icon" title="Add to Wishlist">
                <FiHeart size={18} color="#f5057c" />
            </div>
            <img src={image} alt={name} />
            <h3>{name}</h3>
            <div className="price">
                <span className="mrp">Rs. {mrp}.00</span>
                <span className="discounted">Rs. {price}.00</span>
            </div>
        </div>
    );
}